export default __webpack_public_path__ + "static/brush-stroke-accent-59ac2b4017ba920e759026e7b38e98b9.svg";